import { render, staticRenderFns } from "./Skybook.vue?vue&type=template&id=09f36d3c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f36d3c')) {
      api.createRecord('09f36d3c', component.options)
    } else {
      api.reload('09f36d3c', component.options)
    }
    module.hot.accept("./Skybook.vue?vue&type=template&id=09f36d3c&", function () {
      api.rerender('09f36d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/Skybook.vue"
export default component.exports